import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Ellipsis, type LucideProps } from "lucide-react";

type RowAction<T> = {
	label: string;
	icon: React.ComponentType<LucideProps>;
	onClick: (row: T) => void;
	destructive?: boolean;
};

interface ActionTemplateProps<T> {
	row: T;
	actions: RowAction<T>[];
}

export default function ActionTemplate<T>({ row, actions }: ActionTemplateProps<T>) {
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild className="w-full">
				<span className="text-[13px] text-[var(--secondary-text-color)] cursor-pointer text-700 flex items-center justify-start h-[28px] w-[28px] rounded-[12px]">
					<span className="h-[28px] w-[28px] rounded-full flex items-center justify-center hover:bg-[var(--primary-background-hover-color)] transition-colors duration-300">
						<Ellipsis className="h-4 w-4 rounded-full" />
					</span>
				</span>
			</DropdownMenuTrigger>

			<DropdownMenuContent className="w-[181px] left-[-12px] mr-20">
				{actions?.map((action, index) => (
					<DropdownMenuItem key={index} onClick={() => action.onClick(row)} className="cursor-pointer">
						<action.icon className={`h-4 w-4 ${action.destructive ? "text-[var(--primary-color)]" : "text-[var(--secondary-text-color)]"}`} /> {action.label}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
